export default "__VITE_ASSET__DsduGuTj__"